import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addTarget,
  removeTarget,
  replaceTargets,
  cleanTargets,
  toggleView
} from "../actions";
import Summary from "./Summary";
import SelectedTarget from "./SelectedTarget";
import SearchTarget from "./SearchTarget";
import AndTarget from "./AndTarget";
import NavigationMenu from "./NavigationMenu";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";
import HotKeys from "./HotKeys";

type Props = {
  selectedTargets: []
};
type State = {
  formTarget: string,
  searchTargets: []
};

const mapStateToProps = (state, ownProps) => {
  return {
    selectedTargets: state.selectedTargets
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addTarget: (target, indexa, indexb) => {
      if(indexa === -1 ){
        indexa = 0;
      }
      dispatch(addTarget(target, indexa, indexb));
    },
    removeTarget: (target, index) => dispatch(removeTarget(target, index)),
    replaceTargets: (dragIndexa, dragIndexb, hoverIndexa, hoverIndexb) =>
      dispatch(
        replaceTargets(dragIndexa, dragIndexb, hoverIndexa, hoverIndexb)
      ),
    cleanTargets: () => dispatch(cleanTargets()),
    prevPage: () => dispatch(toggleView("location")),
    nextPage: () => dispatch(toggleView("age"))
  };
};

class TargetsFormContainer extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      formTarget: "",
      searchTargets: [],
      draggingTarget: { id: -1, indexa: -1, indexb: -1, isNew: false }
    };
    (this: any).handleChangNavigationMenue = this.handleChange.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.setDragging = this.setDragging.bind(this);
  }
  handleChange(value: any) {
    if (value !== "") {
      this.setState({
        formTarget: value
      });
      this.fetchTargets(value);
    } else {
      this.setState({
        formTarget: value
      });
      this.setState({ searchTargets: [] });
    }
  }

  onButtonClick(target, index) {
    const length = this.props.selectedTargets[
      this.props.selectedTargets.length - 1 + index
    ]
      ? this.props.selectedTargets[
          this.props.selectedTargets.length - 1 + index
        ].length
      : 0;
    this.props.addTarget(
      target,
      this.props.selectedTargets.length - 1 + index,
      length
    );
  }

  setDragging(id, indexa, indexb, isNew) {
    this.setState(previousState => {
      return {
        draggingTarget: {
          id,
          indexa,
          indexb,
          isNew: isNew != null ? isNew : previousState.draggingTarget.isNew
        }
      };
    });
  }

  fetchTargets(target: string) {
    if (!target) {
      return;
    }
    fetch(
      `${window.config.base_url}/act_10152971550702019/targetingsearch?access_token=${window.config.access_token}&q=${target}&locale=en_GB`
    )
      .then(response => response.json())
      .then(responseJson =>
        this.setState({ searchTargets: responseJson.data })
      );
  }
  prevPage = (e,focus) => {
    if(focus && focus.tagName === "INPUT"){
      return;
    }
    this.props.prevPage();
  }
  nextPage = (e,focus) => {
    if(focus && focus.tagName === "INPUT"){
      return;
    }
    this.props.nextPage();
  }

  render() {
    const keyMap = {
      nextPage: "arrowright",
      prevPage: "arrowleft",
    };

    const handlers = {
      nextPage: this.nextPage,
      prevPage: this.prevPage,
    };
    return (
      <HotKeys keyMap={keyMap} handlers={handlers}>
        <div className="column">
          <h1 className="title">Targetting Selection</h1>
          <h2 className="sub-title">
            Add names of films, actors or themes that you feel are relevant to your project.
          </h2>
          <div className="column__section">
            <form
              onSubmit={event => {
                event.preventDefault();
              }}
            >
              <label className="search__label" htmlFor="target">Search</label>
              <input
                type="text"
                className="input input--text"
                value={this.state.formTarget}
                onChange={e => this.handleChange(e.target.value)}
              />
              <div className="search">
                {this.state.searchTargets &&
                  this.state.searchTargets.map(target => (
                    <SearchTarget
                      target={target}
                      key={target.id + target.type}
                      id={target.id}
                      addTarget={this.onButtonClick}
                      setDragging={this.setDragging}
                      cleanTargets={this.props.cleanTargets}
                    />
                  ))}
                {(!this.state.searchTargets ||
                  this.state.searchTargets.length === 0) &&
                  <p className="search__empty">No results to display yet.</p>}
              </div>
            </form>
            <div className="results">
              <label className="search__label" htmlFor="target">
                Added Target
              </label>
              {this.props.selectedTargets.map((value, index) => (
                <div className="results__block" key={index}>
                  {index !== 0 &&
                    <div className="results__connector"><p>AND</p></div>}
                  {value.map((target, i) => (
                    <SelectedTarget
                      key={target.id + "-" + i + "-" + index}
                      target={target}
                      newTarget={this.state.draggingTarget.isNew}
                      dragging={
                        this.state.draggingTarget.id === target.id &&
                          this.state.draggingTarget.indexa === index &&
                          this.state.draggingTarget.indexb === i
                      }
                      removeTarget={this.props.removeTarget}
                      addTargetItem={this.props.addTarget}
                      cleanTargets={this.props.cleanTargets}
                      moveTargetItem={this.props.replaceTargets}
                      setDragging={this.setDragging}
                      indexa={index}
                      indexb={i}
                      id={target.id}
                    />
                  ))}
                </div>
              ))}
              <AndTarget
                indexa={this.props.selectedTargets.length}
                dragging={this.state.draggingTarget.id !== -1}
                setDragging={this.setDragging}
                moveTargetItem={this.props.replaceTargets}
                cleanTargets={this.props.cleanTargets}
                addTargetItem={this.props.addTarget}
              />
            </div>
          </div>

          <hr className="separator" />

          <NavigationMenu prev="location" next="age" />
          <Summary />
        </div>
      </HotKeys>
    );
  }
}
const TargetsForm = connect(mapStateToProps, mapDispatchToProps)(
  TargetsFormContainer
);

export default DragDropContext(HTML5Backend)(TargetsForm);



// WEBPACK FOOTER //
// ./src/components/TargetsForm.js